import { connect } from 'react-redux'
import ContentPanels from 'pages/dashboard/ContentPanels'
import { setHomePageFcUpdatesIsLoaded } from 'redux/actions'

const mapDispatchToProps = dispatch => ({
  setHomePageFcUpdatesIsLoaded: isLoaded => dispatch(setHomePageFcUpdatesIsLoaded(isLoaded))
})

export default connect(null, mapDispatchToProps)(ContentPanels)
